export interface KanaGroup {
  kana: string[];
  romanji: string[];
  altRomanji?: string[][];
  groupName: string;
}

export const kana: KanaGroup[] = [
  {
    kana: ['あ', 'い', 'う', 'え', 'お'],
    romanji: ['a', 'i', 'u', 'e', 'o'],
    groupName: 'h.b.a',
  },
  {
    kana: ['か', 'き', 'く', 'け', 'こ'],
    romanji: ['ka', 'ki', 'ku', 'ke', 'ko'],
    groupName: 'h.b.k',
  },
  {
    kana: ['さ', 'し', 'す', 'せ', 'そ'],
    romanji: ['sa', 'shi', 'su', 'se', 'so'],
    altRomanji: [[], ['si'], [], [], []],
    groupName: 'h.b.s',
  },
  {
    kana: ['た', 'ち', 'つ', 'て', 'と'],
    romanji: ['ta', 'chi', 'tsu', 'te', 'to'],
    altRomanji: [[], ['ti'], ['tu'], [], []],
    groupName: 'h.b.t',
  },
  {
    kana: ['な', 'に', 'ぬ', 'ね', 'の'],
    romanji: ['na', 'ni', 'nu', 'ne', 'no'],
    groupName: 'h.b.n',
  },
  {
    kana: ['は', 'ひ', 'ふ', 'へ', 'ほ'],
    romanji: ['ha', 'hi', 'fu', 'he', 'ho'],
    altRomanji: [[], [], ['hu'], [], []],
    groupName: 'h.b.h',
  },
  {
    kana: ['ま', 'み', 'む', 'め', 'も'],
    romanji: ['ma', 'mi', 'mu', 'me', 'mo'],
    groupName: 'h.b.m',
  },
  {
    kana: ['や', 'ゆ', 'よ'],
    romanji: ['ya', 'yu', 'yo'],
    groupName: 'h.b.y',
  },
  {
    kana: ['ら', 'り', 'る', 'れ', 'ろ'],
    romanji: ['ra', 'ri', 'ru', 're', 'ro'],
    groupName: 'h.b.r',
  },
  {
    kana: ['わ', 'を', 'ん'],
    romanji: ['wa', 'wo', 'n'],
    altRomanji: [[], [], ['nn']],
    groupName: 'h.b.w',
  },
  {
    kana: ['が', 'ぎ', 'ぐ', 'げ', 'ご'],
    romanji: ['ga', 'gi', 'gu', 'ge', 'go'],
    groupName: 'h.d.g',
  },
  {
    kana: ['ざ', 'じ', 'ず', 'ぜ', 'ぞ'],
    romanji: ['za', 'ji', 'zu', 'ze', 'zo'],
    groupName: 'h.d.z',
  },
  {
    kana: ['だ', 'ぢ', 'づ', 'で', 'ど'],
    romanji: ['da', 'ji', 'zu', 'de', 'do'],
    altRomanji: [[], ['di'], ['du'], [], []],
    groupName: 'h.d.d',
  },
  {
    kana: ['ば', 'び', 'ぶ', 'べ', 'ぼ'],
    romanji: ['ba', 'bi', 'bu', 'be', 'bo'],
    groupName: 'h.d.b',
  },
  {
    kana: ['ぱ', 'ぴ', 'ぷ', 'ぺ', 'ぽ'],
    romanji: ['pa', 'pi', 'pu', 'pe', 'po'],
    groupName: 'h.d.p',
  },
  {
    kana: ['きゃ', 'きゅ', 'きょ'],
    romanji: ['kya', 'kyu', 'kyo'],
    groupName: 'h.y.ky',
  },
  {
    kana: ['ぎゃ', 'ぎゅ', 'ぎょ'],
    romanji: ['gya', 'gyu', 'gyo'],
    groupName: 'h.y.gy',
  },
  {
    kana: ['しゃ', 'しゅ', 'しょ'],
    romanji: ['sha', 'shu', 'sho'],
    groupName: 'h.y.shy',
  },
  {
    kana: ['じゃ', 'じゅ', 'じょ'],
    romanji: ['ja', 'ju', 'jo'],
    groupName: 'h.y.jy',
  },
  {
    kana: ['ちゃ', 'ちゅ', 'ちょ'],
    romanji: ['cha', 'chu', 'cho'],
    groupName: 'h.y.chy',
  },
  {
    kana: ['にゃ', 'にゅ', 'にょ'],
    romanji: ['nya', 'nyu', 'nyo'],
    groupName: 'h.y.ny',
  },
  {
    kana: ['みゃ', 'みゅ', 'みょ'],
    romanji: ['mya', 'myu', 'myo'],
    groupName: 'h.y.my',
  },
  {
    kana: ['りゃ', 'りゅ', 'りょ'],
    romanji: ['rya', 'ryu', 'ryo'],
    groupName: 'h.y.ry',
  },
  {
    kana: ['ひゃ', 'ひゅ', 'ひょ'],
    romanji: ['hya', 'hyu', 'hyo'],
    groupName: 'h.y.hy',
  },
  {
    kana: ['びゃ', 'びゅ', 'びょ'],
    romanji: ['bya', 'byu', 'byo'],
    groupName: 'h.y.by',
  },
  {
    kana: ['ぴゃ', 'ぴゅ', 'ぴょ'],
    romanji: ['pya', 'pyu', 'pyo'],
    groupName: 'h.y.py',
  },
  {
    kana: ['ア', 'イ', 'ウ', 'エ', 'オ'],
    romanji: ['a', 'i', 'u', 'e', 'o'],
    groupName: 'k.b.a',
  },
  {
    kana: ['カ', 'キ', 'ク', 'ケ', 'コ'],
    romanji: ['ka', 'ki', 'ku', 'ke', 'ko'],
    groupName: 'k.b.k',
  },
  {
    kana: ['サ', 'シ', 'ス', 'セ', 'ソ'],
    romanji: ['sa', 'shi', 'su', 'se', 'so'],
    altRomanji: [[], ['si'], [], [], []],
    groupName: 'k.b.s',
  },
  {
    kana: ['タ', 'チ', 'ツ', 'テ', 'ト'],
    romanji: ['ta', 'chi', 'tsu', 'te', 'to'],
    altRomanji: [[], ['ti'], ['tu'], [], []],
    groupName: 'k.b.t',
  },
  {
    kana: ['ナ', 'ニ', 'ヌ', 'ネ', 'ノ'],
    romanji: ['na', 'ni', 'nu', 'ne', 'no'],
    groupName: 'k.b.n',
  },
  {
    kana: ['ハ', 'ヒ', 'フ', 'ヘ', 'ホ'],
    romanji: ['ha', 'hi', 'fu', 'he', 'ho'],
    altRomanji: [[], [], ['hu'], [], []],
    groupName: 'k.b.h',
  },
  {
    kana: ['マ', 'ミ', 'ム', 'メ', 'モ'],
    romanji: ['ma', 'mi', 'mu', 'me', 'mo'],
    groupName: 'k.b.m',
  },
  {
    kana: ['ヤ', 'ユ', 'ヨ'],
    romanji: ['ya', 'yu', 'yo'],
    groupName: 'k.b.y',
  },
  {
    kana: ['ラ', 'リ', 'ル', 'レ', 'ロ'],
    romanji: ['ra', 'ri', 'ru', 're', 'ro'],
    groupName: 'k.b.r',
  },
  {
    kana: ['ワ', 'ヲ', 'ン'],
    romanji: ['wa', 'wo', 'n'],
    altRomanji: [[], [], ['nn']],
    groupName: 'k.b.w',
  },
  {
    kana: ['ガ', 'ギ', 'グ', 'ゲ', 'ゴ'],
    romanji: ['ga', 'gi', 'gu', 'ge', 'go'],
    groupName: 'k.d.g',
  },
  {
    kana: ['ザ', 'ジ', 'ズ', 'ゼ', 'ゾ'],
    romanji: ['za', 'ji', 'zu', 'ze', 'zo'],
    groupName: 'k.d.z',
  },
  {
    kana: ['ダ', 'ヂ', 'ヅ', 'デ', 'ド'],
    romanji: ['da', 'ji', 'zu', 'de', 'do'],
    altRomanji: [[], ['di'], ['du'], [], []],
    groupName: 'k.d.d',
  },
  {
    kana: ['バ', 'ビ', 'ブ', 'ベ', 'ボ'],
    romanji: ['ba', 'bi', 'bu', 'be', 'bo'],
    groupName: 'k.d.b',
  },
  {
    kana: ['パ', 'ピ', 'プ', 'ペ', 'ポ'],
    romanji: ['pa', 'pi', 'pu', 'pe', 'po'],
    groupName: 'k.d.p',
  },
  {
    kana: ['キャ', 'キュ', 'キョ'],
    romanji: ['kya', 'kyu', 'kyo'],
    groupName: 'k.y.ky',
  },
  {
    kana: ['ギャ', 'ギュ', 'ギョ'],
    romanji: ['gya', 'gyu', 'gyo'],
    groupName: 'k.y.gy',
  },
  {
    kana: ['シャ', 'シュ', 'ショ'],
    romanji: ['sha', 'shu', 'sho'],
    groupName: 'k.y.shy',
  },
  {
    kana: ['ジャ', 'ジュ', 'ジョ'],
    romanji: ['ja', 'ju', 'jo'],
    groupName: 'k.y.jy',
  },
  {
    kana: ['チャ', 'チュ', 'チョ'],
    romanji: ['cha', 'chu', 'cho'],
    groupName: 'k.y.chy',
  },
  {
    kana: ['ニャ', 'ニュ', 'ニョ'],
    romanji: ['nya', 'nyu', 'nyo'],
    groupName: 'k.y.ny',
  },
  {
    kana: ['ミャ', 'ミュ', 'ミョ'],
    romanji: ['mya', 'myu', 'myo'],
    groupName: 'k.y.my',
  },
  {
    kana: ['リャ', 'リュ', 'リョ'],
    romanji: ['rya', 'ryu', 'ryo'],
    groupName: 'k.y.ry',
  },
  {
    kana: ['ヒャ', 'ヒュ', 'ヒョ'],
    romanji: ['hya', 'hyu', 'hyo'],
    groupName: 'k.y.hy',
  },
  {
    kana: ['ビャ', 'ビュ', 'ビョ'],
    romanji: ['bya', 'byu', 'byo'],
    groupName: 'k.y.by',
  },
  {
    kana: ['ピャ', 'ピュ', 'ピョ'],
    romanji: ['pya', 'pyu', 'pyo'],
    groupName: 'k.y.py',
  },
  {
    romanji: ['fa', 'fi', 'fe', 'fo', 'fyu'],
    kana: ['ファ', 'フィ', 'フェ', 'フォ', 'フュ'],
    groupName: 'k.f.f',
  },
  {
    romanji: ['wi', 'we', 'wo'],
    kana: ['ウィ', 'ウェ', 'ウォ'],
    groupName: 'k.f.w',
  },
  {
    romanji: ['va', 'vi', 'vu', 've', 'vo'],
    kana: ['ヴァ', 'ヴィ', 'ヴ', 'ヴェ', 'ヴォ'],
    groupName: 'k.f.v',
  },
  {
    romanji: ['ti', 'tu'],
    kana: ['ティ', 'トゥ'],
    groupName: 'k.f.t',
  },
  {
    romanji: ['di', 'du'],
    kana: ['ディ', 'ドゥ'],
    groupName: 'k.f.d',
  },
  {
    romanji: ['she', 'si'],
    kana: ['シェ', 'スィ'],
    groupName: 'k.f.s',
  },
  {
    romanji: ['che', 'je'],
    kana: ['チェ', 'ジェ'],
    groupName: 'k.f.c',
  },
  {
    romanji: ['tsa', 'tsi', 'tse', 'tso'],
    kana: ['ツァ', 'ツィ', 'ツェ', 'ツォ'],
    groupName: 'k.f.ts',
  },
  {
    kana: ['さ', 'ち', 'き'],
    romanji: ['sa', 'chi', 'ki'],
    groupName: 'challenge.similar.sachiki',
  },
  {
    kana: ['れ', 'ね', 'わ'],
    romanji: ['re', 'ne', 'wa'],
    groupName: 'challenge.similar.newa',
  },
  {
    kana: ['る', 'ろ'],
    romanji: ['ru', 'ro'],
    groupName: 'challenge.similar.ruro',
  },
  {
    kana: ['ぬ', 'め'],
    romanji: ['nu', 'me'],
    groupName: 'challenge.similar.nume',
  },
  {
    kana: ['は', 'ほ'],
    romanji: ['ha', 'ho'],
    groupName: 'challenge.similar.haho',
  },
  {
    kana: ['ソ', 'ン', 'シ', 'ツ'],
    romanji: ['so', 'n', 'shi', 'tsu'],
    groupName: 'challenge.katakana.sonshitsu',
  },
  {
    kana: ['ク', 'ワ', 'ウ', 'ラ'],
    romanji: ['ku', 'wa', 'u', 'ra'],
    groupName: 'challenge.katakana.kuwaura',
  },
  {
    kana: ['ク', 'ケ', 'タ'],
    romanji: ['ku', 'ke', 'ta'],
    groupName: 'challenge.katakana.kuketa',
  },
  {
    // タ (ta) vs テ (te) — commonly confused by beginners (see issue #24283)
    kana: ['タ', 'テ'],
    romanji: ['ta', 'te'],
    groupName: 'challenge.katakana.tate',
  },
];
